var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#F0F0F0;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.4,193.7c-5.8,24.2-16.2,19.6-21.2,40.7c-29.9-7.2-48.3-37.2-41.1-67.1c7.2-29.9,37.2-48.3,67.1-41.1 C277.1,168.3,287.6,172,282.4,193.7L282.4,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.9,211.6c21.2,13,13.6,21.4,32.1,32.8c-16.1,26.2-50.3,34.4-76.5,18.3c-26.2-16.1-34.4-50.3-18.4-76.5 C179.1,208.9,185.9,200,204.9,211.6L204.9,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198,290.9c18.9-16.2,24.6-6.3,41.1-20.4c20,23.4,17.2,58.5-6.2,78.5c-23.4,20-58.5,17.2-78.5-6.2 C187.4,314.5,181,305.3,198,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.3,322c-9.5-23,1.6-25.3-6.7-45.4c28.4-11.8,61,1.7,72.7,30.1c11.8,28.4-1.7,61-30.1,72.7 C290.5,339.3,279.8,342.5,271.3,322z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.5,261.9c-24.8,1.9-23.6-9.3-45.3-7.6c-2.4-30.6,20.5-57.4,51.1-59.8c30.6-2.4,57.4,20.5,59.8,51.1 C345.9,249,345.6,260.1,323.5,261.9L323.5,261.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.17fdcfe9b367b3bc95df5a41ad28a3f1.svg";
export { ForwardRef as ReactComponent };